type MessageType = 'Socket In' | 'Socket Out' | 'Notice' | 'Disconnect'

type Message = {
  type: MessageType
  message: string
  data?: any
  timestamp: string
}

class SocketLogClass {
  messages: Message[] = []
  enabled = false

  setEnabled = (enabled: boolean) => {
    this.enabled = enabled
  }

  log = (type: MessageType, message: string, data?: any) => {
    if (!this.enabled) return

    this.messages.push({ type, message, data, timestamp: new Date().toISOString() })
  }

  getMessages = () => this.enabled && this.messages
}

export const SocketLog = new SocketLogClass()

// @ts-ignore
window.SocketLog = SocketLog
